import React from 'react';

import classes from './styles/index.module.scss';

const TaskListBoardColumn: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<div className={classes.taskBoardColumn}>
			<div className={classes.taskBoardColumn_border} />
			{children}
		</div>
	);
};

export { TaskListBoardColumn };
